import { HomeTags } from '@/interfaces/home';
import { getTags } from '@/services/apis/modules/home';
import { useEffect, useState } from 'react';

type ScreenType = "home" | "indicator" | "indicators" | "indicator_local" | "detail_indicator";

const useGetTags = (key: string, screen: ScreenType) => {
  const [tags, setTags] = useState<HomeTags>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        setIsLoading(true);
        const response = await getTags({ key, screen });
        setTags(response?.data || []);
        setError(null);
        setIsLoading(false);
      } catch (err) {
        setError('Failed to fetch tags');
        setIsLoading(false);
      } 
    };

    fetchTags();
  }, []);

  return { tags, isLoading, error };
};

export default useGetTags;
